<template>
    <div class="hot-cmpt">
        <div class="hot-cmpt-container">
            <!-- slogan -->
            <div class="slogan">
                <h1>加入DF，成为数据科学家！</h1>
                <p>Join DF and become a data scientist!</p>
                <img src="@/assets/home/slogan_t@2x.png" alt="" />
            </div>
            <!-- title -->
            <home-title :title="'精选赛题'" :type="1" :moreUrl="'/competitions'" />
            <!-- {{cmptData}} -->
            <!-- <div class="cmpt-item" v-for="cmpt in data" :key="cmpt.id" @click="handleClickItem(cmpt)">
                <div class="cmpt-item-left">
                    <div class="title" style="-webkit-box-orient: vertical">{{ cmpt.title }}</div>
                    <div class="attr">
                        <div class="reward">
                            <i class="df-icon df-icon-bonus"></i>
                            <span>{{ `${toThousands(cmpt.bonus)}` }}</span>
                        </div>
                        <div class="users">
                            <i class="df-icon df-icon-users"></i>
                            <span>{{ cmpt.competitors }}+</span>
                        </div>
                    </div>
                </div>
                <div class="cmpt-item-right">
                    <img :src="cmpt.bannerUrl" :alt="cmpt.title" />
                </div>
            </div> -->
            
            <cmpt-item :cmpt="cmptData[0]" :isHome="true" :isHomeFirst="true" />
        </div>
        <cmpt-item :cmpt="cmpt" v-for="cmpt in cmptData.slice(1)" :key="cmpt.id" />
    </div>
</template>

<script>
import HomeTitle from './HomeTitle.vue';
import CmptItem from '../common/cmpt-item'
export default {
    data() {
        return {
            // data: [],
        };
    },
    props: {
        cmptData: {
            type: Array,
            default(){
                return []
            }
        }
    },

    components: { HomeTitle, CmptItem },

    computed: {
        user() {
            return this.$store.getters.userInfo;
        },
    },

    methods: {
        // async getData() {
        //     const { data } = await this.$axios('getHomeHotCmpt', { type: 2, page: 1, pageSize: 3 });
        //     this.data = data;
        // },

        // 奖金序列化
        toThousands(num) {
            var result = '',
                counter = 0;
            num = (num || 0).toString();
            for (var i = num.length - 1; i >= 0; i--) {
                counter++;
                result = num.charAt(i) + result;
                if (!(counter % 3) && i != 0) {
                    result = ',' + result;
                }
            }
            return result;
        },
        handleClickItem(item) {
            if (item.linkUrl.indexOf('datafountain.cn' > -1)) {
                this.$router.push(item.linkUrl.split('datafountain.cn')[1])
            } else {
                this.$router.push(item.linkUrl);
            }
        },
    },

    created() {
        // this.getData();
    },
};
</script>

<style lang="scss" scoped>
.hot-cmpt {
    margin-top: 22px;
    // padding: 0 14px;
    .hot-cmpt-container {
        width: 724px;
        max-height: 912px;
        background: #ffffff;
        border-radius: 28px;
        padding-top: 22px;
        margin: 0 14px;

        .slogan {
            width: 670px;
            height: 108px;
            background: #e2f3ff;
            box-shadow: 0px 16px 18px 0px rgba(237, 247, 255, 1);
            border-radius: 28px;
            position: relative;
            margin: 0 26px;
            margin-bottom: 50px;
            padding-left: 24px;
            padding-top: 20px;
            h1 {
                margin: 0;
                font-size: 28px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3a6ce5;
            }
            p {
                font-size: 22px;
                font-family: PingFangSC-Light, PingFang SC;
                font-weight: 300;
                color: #3a6ce5;
                line-height: 38px;
                margin: 0;
                transform: translateY(-6px);
            }
            img {
                position: absolute;
                right: 18px;
                bottom: 0;
                width: 274px;
                height: 138px;
            }
        }

        // .cmpt-item {
        //     display: flex;
        //     justify-content: space-between;
        //     height: 216px;
        //     width: 686px;
        //     border-bottom: 2px solid #f3f3f4;
        //     margin: 0 auto;
        //     padding: 8px;
        //     padding-top: 38px;
        //     padding-bottom: 40px;
        //     background: #FFF;

        //     &:nth-last-of-type(1) {
        //         border-bottom: none;
        //     }

        //     .cmpt-item-left {
        //         width: 420px;
        //         height: 138px;
        //         position: relative;
        //         top: 4px;
        //         .title {
        //             width: 420px;
        //             height: 80px;
        //             line-height: 40px;
        //             font-size: 28px;
        //             font-family: PingFangSC-Medium, PingFang SC;
        //             font-weight: 500;
        //             color: #232526;

        //             display: -webkit-box;
        //             /* autoprefixer: off */
        //             -webkit-box-orient: vertical;
        //             /* autoprefixer: on */
        //             -webkit-line-clamp: 2;
        //             overflow: hidden;
        //         }
        //         .attr {
        //             width: 100%;
        //             position: absolute;
        //             bottom: 0;
        //             left: 0;
        //             display: flex;
        //             justify-content: space-between;
        //             // transform: translateY(10px);
        //             height: 40px;
        //             width: 400px;
        //             // border: 1px solid #000;
        //             .reward {
        //                 font-size: 30px;
        //                 font-family: PingFangSC-Medium, PingFang SC;
        //                 font-weight: 500;
        //                 color: #3a6de6;
        //                 // border: 1px solid rgb(153, 149, 142);
        //             }
        //             .users {
        //                 font-size: 26px;
        //                 font-family: PingFangSC-Medium, PingFang SC;
        //                 font-weight: 500;
        //                 color: #9da1a9;
        //                 // border: 1px solid pink;
        //                 transform: translateY(4px);
        //             }
        //             .df-icon {
        //                 display: inline-block;
        //                 width: 28px;
        //                 height: 24px;
        //                 margin-right: 6px;
        //                 transform: translateY(2px);
        //             }
        //             .df-icon-bonus {
        //                 background: url('../../assets/home/bonus@2x.png') no-repeat center center;
        //                 background-size: 28px 24px;
        //             }
        //             .df-icon-users {
        //                 background: url('../../assets/home/users@2x.png') no-repeat center center;
        //                 background-size: 28px 24px;
        //             }
        //         }
        //     }
        //     .cmpt-item-right {
        //         img {
        //             width: 200px;
        //             height: 138px;
        //             border-radius: 8px;
        //         }
        //     }
        // }
    }
}
</style>
